const backToTop = document.querySelector('.backTop');

if (backToTop) {
    let visible = false;

    window.addEventListener('scroll', () => {
        if (window.pageYOffset > 220) {
            if (!visible) {
                visible = true;
                backToTop.classList.add('backTop--visible');
            }
        } else {
            if (visible) {
                visible = false;
                backToTop.classList.remove('backTop--visible');
            }
        }
    });

    backToTop.addEventListener('click', (event) => {
        event.preventDefault();

        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({
                left: 0,
                top: 0,
                behavior: 'smooth',
            });
        } else {
            window.scrollTo(0, 0);
        }
    });
}
